import { render, staticRenderFns } from "./SimilarHeatMap.vue?vue&type=template&id=49da5a30&scoped=true&"
import script from "./SimilarHeatMap.vue?vue&type=script&lang=js&"
export * from "./SimilarHeatMap.vue?vue&type=script&lang=js&"
import style0 from "./SimilarHeatMap.vue?vue&type=style&index=0&id=49da5a30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49da5a30",
  null
  
)

export default component.exports